import {lazyRegister} from '@/Core/lazyRegister';
import './loading-indicator.component.css';
import template from './loading-indicator.component.html';

class LoadingIndicatorController {
    static $inject = ['$element'];

    private type: 'circle' | 'box';

    constructor(private $element) {
    }

    $onInit(): void {
        this.$element.addClass('loading-indicator');
    }
}

export const LoadingIndicatorComponent: ng.IComponentOptions = {
    bindings: {
        type: '@?',
        boxClass: '@?'
    },
    template: template,
    controller: LoadingIndicatorController
};

lazyRegister.component('loadingIndicator', LoadingIndicatorComponent);